
      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("fKMkO", function(module, exports) {
module.exports = JSON.parse("{}");

});


//# sourceMappingURL=en-US.376b9ec8.js.map
